<template>
  <div class="set-bg">
    <div class="list" v-show="!isShow">
      <ul>
        <li>
          <div class="choose">
            <button @click="quit('choose')"></button>
          </div>
          <div><p>选择卡面</p></div>
        </li>
        <li>
          <div class="camera">
            <input
              type="file"
              accept="image/*"
              capture="camera"
              @change="openCamera"
            />
          </div>
          <div><p>打开相机</p></div>
        </li>
        <li>
          <div class="photo">
            <input type="file" accept="image/*" @change="openCamera" />
          </div>
          <div><p>相册上传</p></div>
        </li>
      </ul>
    </div>
    <div v-show="isShow">
      <div class="title">
        <p>请选择你的背景图</p>
        <button @click="quit('quit')"></button>
      </div>
      <div class="c-img">
        <ul @click="choice">
          <li v-for="(item, index) of image" :key="index">
            <img :src="item" />
          </li>
        </ul>
      </div>
      <div class="c-btn"><button @click="quit('quit')">确定</button></div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: false,
      image: [
        require('../../../../../assets/gift/banner1.png'),
        require('../../../../../assets/gift/banner2.png'),
        require('../../../../../assets/gift/banner3.png'),
      ]
    }
  },
  methods: {
    openCamera (e) {
      let that = this
      let reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = function () {
        that.$emit("bgimg", this.result, true)
      }
    },
    choice (e) {

      this.$emit("bgimg", e.target.src, true)
    },
    choose () {

    },
    quit (type) {
      if (type === 'choose') {
        this.isShow = true
        this.$emit('quit', false)
        return
      }
      if (type === 'quit') {
        this.isShow = false
        this.$emit('quit', true)
      }

    }
  }
}
</script>
<style lang="scss" scoped>
body {
  padding: 0px !important;
}
.set-bg {
  font-size: 0.28rem;

  background: white;

  .list {
    ul {
      @include flexBox(space-around);
      margin-top: 0.2rem;
      padding-top: 0.5rem;
      border-top: 1px solid #e4e4e4;
      li {
        img {
          height: 1.26rem;
        }
        p {
          text-align: center;
          margin: 0.08rem 0;
          color: #666666;
        }
      }
    }

    .choose {
      button {
        width: 1.26rem;
        height: 1.26rem;
        background: url("../../../../../assets/icon/card.png") white no-repeat
          50%/0.6rem;
        border-radius: 50%;
        border: none;
      }
    }
    .camera {
      background: url("../../../../../assets/icon/camera.png") white no-repeat
        50%/0.6rem;
      border-radius: 50%;
      input {
        width: 1.26rem;
        height: 1.26rem;
        opacity: 0;
      }
    }
    .photo {
      @extend .camera;
      background: url("../../../../../assets/icon/photo.png") white no-repeat
        50%/0.6rem;
    }
  }
  .title {
    text-align: center;
    display: flex;
    border: 1px solid rgb(231, 231, 231);
    p {
      width: 7rem;
      color: #ff6161;
    }
    button {
      width: 1.05rem;
      height: 1.26rem;
      display: inline-block;
      background: url("../../../../../assets/icon/quit.png") white no-repeat 50%/0.48rem;
      border: 1px solid rgb(231, 231, 231);
    }
  }
  .c-img {
    margin-top: 0.8rem;
    ul {
      @include flexBox(space-around);
    }
  }
  .c-btn {
    margin-top: 1rem;
    text-align: center;
    button {
      width: 4.68rem;
      height: 0.99rem;
      border: none;
      background: #ffc44e;
      border-radius: 30px;
      color: white;
    }
  }
}
</style>